module.exports = __webpack_public_path__ + "img/dbclick.260037cc.png";